/**
 * web-account-pages D1, D4 — one booking (`/account/bookings/:bookingId`); signed out, the sign-in step
 * in place, and once signed in the same booking at the same address. Not this client's booking: the
 * studio's not-found page; any other failed read offers Try again. Below 768px the app's booking
 * page (D8).
 */
import { useParams } from 'react-router-dom';

import { SiteFetchError } from '../../api/site';
import { useWebBooking } from '../../hooks/useWebBooking';
import { PhoneBooking } from '../../phone/PhoneBooking';
import { BookingPage as BookingPagePiece } from '../../pieces/booking-page';
import { useAppScreens } from '../../ui/useIsPhone';
import { usePageTitle } from '../../ui/usePageTitle';
import { NotFoundPage } from '../NotFoundPage';
import { SignedInOnly } from './SignedInOnly';

function Booking() {
  const { bookingId = '' } = useParams<{ bookingId: string }>();
  const { detail } = useWebBooking(bookingId);
  const phone = useAppScreens();
  // Not this client's booking (or no such booking): the studio's not-found page. Any other failure
  // offers Try again, the app's error screen on a phone and the page's own on a computer (rows B2a, B2b).
  const notFound = detail.error instanceof SiteFetchError && detail.error.status === 404;
  if (detail.isError && notFound) return <NotFoundPage />;
  return phone ? <PhoneBooking /> : <BookingPagePiece />;
}

export function BookingPage() {
  usePageTitle('Your booking');
  return (
    <SignedInOnly>
      <Booking />
    </SignedInOnly>
  );
}
